<template>
  <div class="container mall">
    <div class="mall-header">
      <van-field
        center
        clearable
        readonly
        placeholder="请输入关键词进行搜索"
        @click="$router.push('/mall/search')"
      >
        <van-icon slot="left-icon" name="search" />
      </van-field>
    </div>
    <div class="mall-body">
      <van-sidebar v-model="activeKey" @change="onChange">
        <van-sidebar-item v-for="column in columnData" :key="column.id" :title="column.name" />
      </van-sidebar>
      <div class="mall-content" ref="goods">
        <div class="sec_type">
          <div class="sec_type_list" :class="{'current': !secColumnID}" @click="secChange('')">全部</div>
          <div
            class="sec_type_list"
            :class="{'current': secColumnID === secColumn.id}"
            v-for="secColumn in secColumnData"
            :key="secColumn.id"
            @click="secChange(secColumn.id)"
          >
            {{secColumn.name}}
          </div>
        </div>
        <van-list
          v-model="loading"
          :finished="finished"
          :immediate-check="false"
          ref="goodsList"
          :finished-text="productData.length > 0 ? '已全部加载完成' : ''"
          :error.sync="error"
          error-text="请求失败，点击重新加载"
          @load="onLoad"
        >
          <div
            v-for="product in productData"
            :key="product.id"
            class="goods-list"
            @click="$router.push({path: '/mall/view', query: {id: product.id}})"
          >
            <div class="goods-img" :style="{backgroundImage: 'url(' + product.logo + ')'}">
              <van-tag type="primary" v-if="product.isrecommend"><i class="iconfont iconshujituijian"></i>推荐</van-tag>
            </div>
            <div class="goods-info">
              <div class="goods-title van-multi-ellipsis--l2">{{product.productname}}</div>
              <div class="goods-price">¥{{product.price}}</div>
            </div>
          </div>
        </van-list>
        <div class="noData" v-if="finished && productData.length === 0">
          <img src="../../assets/images/noData.png" alt="">
          <p>抱歉，暂无相关商品</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  const pageload = 10
  export default {
    name: 'mallIndex',
    data () {
      return {
        loading: false,
        finished: false,
        error: false,
        index: 1,
        activeKey: 0,
        columnData: [],
        secColumnData: [],
        scrollT: 0,
        columnID: '',
        secColumnID: '',
        productData: []
      }
    },
    created () {
      this.$toast.allowMultiple()
      const load = this.$toast({
        type: 'loading',
        duration: 0,
        loadingType: 'spinner',
        forbidClick: true
      })
      this.$fetch.get(API.PRODUCTTYPELIST).then(response => {
        // console.log(response)
        load.clear()
        if (response.status !== 200) {
          var msg = response.message? response.message : '商品栏目获取失败，请刷新！'
          this.$toast.fail(msg)
          return
        }
        this.columnData = response.data
        if (response.data.length > 0) {
          this.columnID = response.data[0].id
          this.secColumnData = response.data[0].children
          this.$refs.goodsList.check()
        }
      }).catch(error => {
        console.log(error)
        load.clear()
      })
      if (u.indexOf('MicroMessenger') > -1) {
        this.$fetch.get(API.GETWECHATINVOKESIGN, {
          url: window.location.href
        }).then(res => {
          let data = res.data
          wx.config({
            debug: false,
            appId: data.appId, // 必填，公众号的唯一标识
            timestamp: data.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.nonceStr, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: ['onMenuShareTimeline', 'updateAppMessageShareData', 'updateTimelineShareData', 'onMenuShareWeibo'] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          })
          wx.ready(function(){
            wx.updateAppMessageShareData({
              title: '广东科技报-粤科网',
              desc: '传播最新科技资讯、普及科学知识。',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              }
            })
            wx.updateTimelineShareData({
              title: '广东科技报-粤科网',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              }
            })
            wx.onMenuShareWeibo({
              title: '广东科技报-粤科网',
              desc: '传播最新科技资讯、普及科学知识。',
              link: window.location.href,
              imgUrl: 'https://cdn-1300993597.cos.ap-guangzhou.myqcloud.com/image/common/gdkjb.jpg',
              success: function() {
                console.log('分享成功')
              },
              cancel: function(){
                console.log('分享取消')
              }
            })
          })
        })
      }
    },
    activated () {
      this.$nextTick(function () {
        this.$refs.goods.scrollTop = this.scrollT
      })
    },
    methods: {
      onChange (index) {
        // console.log(index)
        this.columnID = this.columnData[index].id
        this.secColumnID = ''
        if (this.columnData[index].children) {
          this.secColumnData = this.columnData[index].children
        } else {
          this.secColumnData = []
        }
        this.productData = []
        this.index = 1
        this.$nextTick(function () {
          this.finished = false
          this.$refs.goodsList.check()
        })
      },
      secChange (id) {
        // console.log(id)
        this.secColumnID = id
        this.productData = []
        this.index = 1
        this.$nextTick(function () {
          this.finished = false
          this.$refs.goodsList.check()
        })
      },
      onLoad () {
        this.$fetch.get(API.PRODUCTLIST, {
          producttypeid: this.columnID,
          subtypeid: this.secColumnID,
          searchkeywords: '',
          pageNum: this.index,
          pageSize: pageload
        }).then(response => {
          // console.log(response)
          if (response.status !== 200) {
            var msg = response.message? response.message : '商品获取失败，请刷新！'
            this.$toast.fail(msg)
            this.loading = false
            this.finished = true
            this.error = true
            return
          }
          if (response.data.productList.length > 0) {
            this.productData = this.productData.concat(response.data.productList)
            this.index += 1
            this.loading = false
            if (response.data.productList.length < pageload) {
              this.finished = true
            }
          } else {
            this.loading = false
            this.finished = true
          }
        }).catch(error => {
          console.log(error)
          this.loading = false
          this.finished = true
          this.error = true
        })
      }
    },
    beforeRouteLeave (to, from, next) {
      this.scrollT = this.$refs.goods.scrollTop
      next()
    }
  }
</script>

<style lang="stylus">
  
</style>